export class ProfileVerificationStatus {
  Id: number;
  EmpCode: number;
  SectionId: string;
  Status: boolean;
  FirstName: string;
  Submitted: boolean;
  Name: string;
  Email: string;
  
}
